import React from 'react';

export default function BookItem(props) {
  const { book } = props;

  return <li><a href={book?.link}>{book?.name}</a> | {book?.author} | {book?.year} | {book?.category}</li>;
}
